export type TrafficService = 'storage' | 'compute';
export type TrafficData = Partial<Record<TrafficService, number>>;
export interface ServicReceiptFetchData {
    traffic?: number;
    items?: ServicReceiptFetchData[];
}

export function extractTrafficData(services: string[], data: ServicReceiptFetchData[]) {
    const result: TrafficData = {};
    services.forEach((service, index) => {
        const serviceData = data[index];

        if (checkIsServiceHasTraffic(serviceData)) {
            const type = service === 'storage' ? 'storage' : 'compute';
            let serviceSumm = result[type] || 0;

            if (serviceData.items) {
                serviceSumm += serviceData.items.reduce((sum, {traffic = 0}) => sum + traffic, 0);
            } else if (serviceData.traffic) {
                serviceSumm += serviceData.traffic;
            }

            result[type] = serviceSumm;
        }
    });

    return result;
}

function checkIsServiceHasTraffic(data: ServicReceiptFetchData) {
    return (
        data.traffic !== undefined ||
        (data.items && data.items.some(({traffic}) => traffic !== undefined))
    );
}
